import Button from 'src/components/Buttons/Button/Button'

export interface StepFooterProps {
  primaryText?: string | null
  onPrimary?: () => void
  primaryLoading?: boolean
  primaryDisabled?: boolean
  onBack?: (() => void) | null
  backText?: string
  className?: string
}

/**
 * The step buttons every screen shares: primary on the right, Back beside it
 * on desktop only (mobile uses the header chevron). Without a primary
 * (nothing to save yet) only Back remains.
 */
const StepFooter = ({
  primaryText = null,
  onPrimary = () => {},
  primaryLoading = false,
  primaryDisabled = false,
  onBack = null,
  backText = 'Back',
  className = '',
}: StepFooterProps) => (
  <div
    className={`flex w-full flex-col gap-4 sm:flex-row-reverse ${className}`}
  >
    {primaryText && (
      <Button
        text={primaryText}
        onClick={onPrimary}
        className="h-11 w-full rounded-lg text-sm font-semibold sm:w-auto sm:min-w-40"
        loading={primaryLoading}
        disabled={primaryDisabled}
      />
    )}
    {onBack && (
      <Button
        text={backText}
        onClick={onBack}
        variant="outline"
        className="hidden h-11 w-full rounded-lg text-sm font-semibold sm:block sm:w-auto sm:min-w-40"
      />
    )}
  </div>
)

export default StepFooter
